import { render } from "./pointgps.vue?vue&type=template&id=4b78a01f&scoped=true"
import script from "./pointgps.vue?vue&type=script&lang=js"
export * from "./pointgps.vue?vue&type=script&lang=js"

import "./pointgps.vue?vue&type=style&index=0&id=4b78a01f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b78a01f"]])

export default __exports__